import { createReducer } from "@reduxjs/toolkit";

import {
  getCreateSubscriptionPosts,
  getCreateSubscriptionPostsSuccess,
  getCreateSubscriptionPostsFailure,
  getMoreCreateSubscriptionPosts,
  getMoreCreateSubscriptionPostsSuccess,
  getMoreCreateSubscriptionPostsFailure,
  getCreateSubscriptionPostsReset,
} from "./actions";

const initialState = {
  isFetchingRestOfPosts: false,
  isLoading: false,
  error: undefined,
  totalCount: undefined,
  allPosts: [],
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getCreateSubscriptionPosts.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(getCreateSubscriptionPostsSuccess.type, (state, { payload }) => ({
      ...state,
      ...payload,
      isLoading: false,
    }))
    .addCase(getCreateSubscriptionPostsFailure.type, (state, { payload }) => ({
      ...state,
      isLoading: false,
      error: payload,
    }))
    .addCase(getMoreCreateSubscriptionPosts.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(
      getMoreCreateSubscriptionPostsSuccess.type,
      (state, { payload }) => ({
        ...state,
        allPosts: [...state.allPosts, ...payload.allPosts],
        totalCount: payload.totalCount,
        isLoading: false,
      }),
    )
    .addCase(getMoreCreateSubscriptionPostsFailure.type, (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
    }))
    .addCase(getCreateSubscriptionPostsReset, () => ({
      ...initialState,
    }));
});
